import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Dialog,
  Select,
  Divider,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import dayjs from "dayjs";
import moment from "moment";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import Other from "../ScientificResearchInsertForm/Other";
import Chapter from "../ScientificResearchInsertForm/Chapter";
import Conference from "../ScientificResearchInsertForm/Conference";
import WorkingPaper from "../ScientificResearchInsertForm/WorkingPaper";
import JournalDomestic from "../ScientificResearchInsertForm/JournalDomestic";
import ConferenceDomestic from "../ScientificResearchInsertForm/ConferenceDomestic";
import JournalInternational from "../ScientificResearchInsertForm/JournalInternational";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { uploadMultiFile } from "../../../reducer/file/action";
import { resetDetail } from "../../../reducer/journal/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import {
  insertScientificResearchOther,
  updateScientificResearchOther,
} from "../../../reducer/scientificResearchOther/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import {
  insertScientificResearch,
  updateScientificResearch,
  checkDuplicatePublication,
} from "../../../reducer/scientificResearch/action";
import { getTimeResearchInformation } from "../../../reducer/timeResearchInformation/action";
import { notification } from "../../../reducer/home/action";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";
import DuplicateCheckModal from "../../../components/ScientificResearch/DuplicateCheckModal";

function SolutionInsertModal(props) {
  const { inserting, setInserting, getTimeResearchInformation } = props;

  const [detail, setDetail] = useState(null);
  const [values, setValues] = useState({
    purposeId: 5,
    departmentId: props.profileDepartments?.[0]?.id || null,
  });
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [studentHelperText, setStudentHelperText] = useState(false);
  const currentYear = getCurrentSchoolYear();
  const [timeResearchYear, setTimeResearchYear] = useState(currentYear);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const dateFormat = (value) => (value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ") : null);

  // Tự gán bản thân vào danh sách tác giả
  useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInPaper: "main",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [props.inserting, props.profile?.id]);

  // Đổi filter thì reset giá trị
  useEffect(() => {
    setDetail(null);
    setValues({ purposeId: 5 });
    setProfileList([]);
    setStudentList([]);
  }, [props.filter]);

  // Bỏ KPI bỏ luôn contract
  // useEffect(() => {
  //   if (!values?.profileIdForKpi) handleChangeForm("contractIdForKpi", null);
  // }, [values?.profileIdForKpi]);

  useEffect(() => {
    if (
      props.timeResearchInformationList.slice(0, 1)?.shift()?.year !== timeResearchYear &&
      !props.isFetchingTimeResearchInformation
    )
      getTimeResearchInformation(0, timeResearchYear);
  }, [timeResearchYear]);

  const handleChangeForm = (name, value) => {
    setValues({ ...values, [name]: value });
    if (name === "purposeId") {
      setValues({
        ...values,
        purposeId: value,
        profileIdForKpi: null,
        contractIdForKpi: null,
        profileIdForReward: null,
      });
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInPaper: "member",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);

    const temp = profileList.filter((e, id) => id !== index);
    setProfileList([...temp]);
  };

  const handleChangeStudentList = (index, name, value) => {
    const temp = studentList;
    const tempElm = studentList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setStudentList([...temp]);
  };

  const handleInsertStudent = () => {
    const temp = studentList;
    temp.push({
      studentName: "",
      studentCode: "",
      class: "",
      major: "",
      cohort: "",
      identity: "",
      isInternal: false,
      externalName: "",
      roleInPaper: "member",
    });
    setStudentList([...temp]);
  };

  const handleRemoveStudent = (index) => {
    const temp = studentList.filter((e, id) => id !== index);
    setStudentList([...temp]);
  };

  const handleClose = () => {
    setInserting(false);
    props.resetDetail();
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(false);
    setNewFiles([]);
  };

  const checkForDuplicates = async () => {
    // Check for duplicates before submitting
    const checkPayload = {
      publicationType: "scientific_researchs",
      title: values?.title || "",
      issn: values?.doi || "",
    };

    const result = await props.checkDuplicatePublication(checkPayload);

    // If API call failed, prevent submission
    if (result.error) {
      return "error"; // Return "error" to stop submission and show error message
    }

    if (result.success && result.data && result.data.length > 0) {
      setDuplicateList(result.data);
      setDuplicateModalOpen(true);
      return true;
    }
    return false;
  };

  const handleSubmit = async (e, skipDuplicateCheck = false) => {
    props.resetDetail();

    // Validate student list - only if there are students added
    const hasInvalidStudents =
      studentList.length > 0 &&
      studentList.findIndex((e) => e.studentName === "" || e.identity === "" || !e.roleInPaper) >= 0;

    if (hasInvalidStudents) {
      setStudentHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    if (profileList.findIndex((e) => e.profileId === null && e.externalName === "") < 0) {
      // Check for duplicates first unless explicitly skipped
      if (!skipDuplicateCheck && !pendingSubmit) {
        const hasDuplicates = await checkForDuplicates();
        if (hasDuplicates === "error") {
          // API error occurred, don't show modal, just stop submission
          return;
        }
        if (hasDuplicates) {
          setPendingSubmit(true);
          return;
        }
      }

      // Only close modal and proceed with submission after duplicate check passes
      setInserting(false);
      const d = new Date();

      const tempListAuthor = values?.listAuthor?.split(",").map((author) => author.trimStart());

      if (props.filter !== "other") {
        if (props.filter === "conference") {
          // if (values.conferenceId) {
          props
            .insertScientificResearch({
              ...values,
              dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
              listAuthor: tempListAuthor,
              journalId: values?.journalId,
              journalDomesticId: values?.journalDomesticId,
              conferenceId:
                props.filter === "conference"
                  ? values.conferenceId
                  : props.filter === "conferenceDomestic"
                    ? values.conferenceDomesticId
                    : null,
              conferenceDomesticId: null,
              profileId: props.profile?.id,
              scientificResearchProfile: profileList,
              type: props.type,
              acceptedDay: dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD")),
              submissionDay: dateFormat(values?.submissionDay || moment().format("YYYY-MM-DD")),
              accepted: props.type === "working" ? true : false,
              page: typeof values.page === "number" ? values.page.toString() : values.page,
              // type: props.filter === 'chapter' ? 'book' : 'scientificResearch', // working
            })
            .then(async (response) => {
              if (response.success && response.data?.scientificResearch?.id && newFiles.length > 0) {
                const uploadResult = await props.uploadMultiFile(
                  response.data.scientificResearch.id,
                  newFiles,
                  "scientificResearch",
                );
                if (uploadResult.success && uploadResult.data) {
                  const urls = Array.isArray(uploadResult.data) ? uploadResult.data : [uploadResult.data];
                  props.updateScientificResearch(response.data.scientificResearch.id, {
                    ...response.data.scientificResearch,
                    fileUrl: urls.join("||"),
                  });
                }
              }
              props.statisticUnaccepted({
                departmentId: 0,
                profileId: props.profile?.id,
                other: props.other,
              });
              if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
            })
            .catch();
          // } else {
          //   // // console.log("safadfsd");
          //   props.pushNoti({
          //     type: "error",
          //     message:
          //       "Không có dữ liệu hội thảo. Bạn vui lòng nhập ở mục tạp chí khác.",
          //   });
          // }
        }
        if (props.filter === "conferenceDomestic") {
          // if (values.conferenceDomesticId) {
          props
            .insertScientificResearch({
              ...values,
              dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
              listAuthor: tempListAuthor,
              journalId: values?.journalId,
              journalDomesticId: values?.journalDomesticId,
              conferenceId:
                props.filter === "conference"
                  ? values.conferenceId
                  : props.filter === "conferenceDomestic"
                    ? values.conferenceDomesticId
                    : null,
              conferenceDomesticId: null,
              profileId: props.profile?.id,
              scientificResearchProfile: [...profileList, ...studentList],
              type: props.type,
              acceptedDay: dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD")),
              submissionDay: dateFormat(values?.submissionDay || moment().format("YYYY-MM-DD")),
              accepted: props.type === "working" ? true : false,
              page: typeof values.page === "number" ? values.page.toString() : values.page,
              // type: props.filter === 'chapter' ? 'book' : 'scientificResearch', // working
            })
            .then(async (response) => {
              if (response.success && response.data?.scientificResearch?.id && newFiles.length > 0) {
                const uploadResult = await props.uploadMultiFile(
                  response.data.scientificResearch.id,
                  newFiles,
                  "scientificResearch",
                );
                if (uploadResult.success && uploadResult.data) {
                  const urls = Array.isArray(uploadResult.data) ? uploadResult.data : [uploadResult.data];
                  props.updateScientificResearch(response.data.scientificResearch.id, {
                    ...response.data.scientificResearch,
                    fileUrl: urls.join("||"),
                  });
                }
              }
              props.statisticUnaccepted({
                departmentId: 0,
                profileId: props.profile?.id,
                other: props.other,
              });
              if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
            })
            .catch();
          // } else {
          //   props.pushNoti({
          //     type: "warning",
          //     message:
          //       "Không có dữ liệu hội thảo. Bạn vui lòng nhập ở mục tạp chí khác.",
          //   });
          // }
        }
        if (props.filter !== "conferenceDomestic" && props.filter !== "conference") {
          props
            .insertScientificResearch({
              ...values,
              dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
              listAuthor: tempListAuthor,
              journalId: values?.journalId,
              journalDomesticId: values?.journalDomesticId,
              conferenceId:
                props.filter === "conference"
                  ? values.conferenceId
                  : props.filter === "conferenceDomestic"
                    ? values.conferenceDomesticId
                    : null,
              conferenceDomesticId: null,
              profileId: props.profile?.id,
              scientificResearchProfile: [...profileList, ...studentList],
              type: props.type,
              acceptedDay: dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD")),
              submissionDay: dateFormat(values?.submissionDay || moment().format("YYYY-MM-DD")),
              accepted: props.type === "working" ? true : false,
              page: typeof values.page === "number" ? values.page.toString() : values.page,
              // type: props.filter === 'chapter' ? 'book' : 'scientificResearch', // working
            })
            .then(async (response) => {
              if (response.success && response.data?.scientificResearch?.id && newFiles.length > 0) {
                const uploadResult = await props.uploadMultiFile(
                  response.data.scientificResearch.id,
                  newFiles,
                  "scientificResearch",
                );
                if (uploadResult.success && uploadResult.data) {
                  const urls = Array.isArray(uploadResult.data) ? uploadResult.data : [uploadResult.data];
                  props.updateScientificResearch(response.data.scientificResearch.id, {
                    ...response.data.scientificResearch,
                    fileUrl: urls.join("||"),
                  });
                }
              }
              props.statisticUnaccepted({
                departmentId: 0,
                profileId: props.profile?.id,
                other: props.other,
              });
              if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
            })
            .catch();
        }
      } else {
        // change scientific other
        props
          .insertScientificResearch({
            ...values,
            score: values.score || 0,
            listAuthor: tempListAuthor,
            scientificResearchOtherProfile: [...profileList, ...studentList],
            // publishAt: dateFormat(values?.publishAt || moment().format("YYYY-MM-DD")),
            acceptedDay: dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD")),
            submissionDay: dateFormat(values?.submissionDay || moment().format("YYYY-MM-DD")),
            dashboardYear: new Date(dateFormat(values?.acceptedDay || moment().format("YYYY-MM-DD"))).getFullYear(),
            type: "scientificResearchOther",
            page: typeof values.page === "number" ? values.page.toString() : values.page,
          })
          .then(async (response) => {
            // console.log("Insert scientificResearchOther response:", response);
            if (response.success && response.data?.scientificResearch?.id && newFiles.length > 0) {
              const uploadResult = await props.uploadMultiFile(
                response.data.scientificResearch.id,
                newFiles,
                "scientificResearchOther",
              );
              if (uploadResult.success && uploadResult.data) {
                const urls = Array.isArray(uploadResult.data) ? uploadResult.data : [uploadResult.data];
                props.updateScientificResearch(response.data.scientificResearch.id, {
                  ...response.data.scientificResearch,
                  fileUrl: urls.join("||"),
                });
              }
            }
            props.statisticUnaccepted({
              departmentId: 0,
              profileId: props.profile?.id,
              other: props.other,
            });
            if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
          })
          .catch();
      }

      setValues(null);
      setProfileList([]);
      setStudentList([]);
      setHelperText(false);
      setStudentHelperText(false);
      setPendingSubmit(false);
      setNewFiles([]);
    } else {
      setHelperText(true);
      return;
    }
  };

  const handleSelectDuplicate = (duplicateItem) => {
    // Close duplicate modal and open update modal with the selected item
    setDuplicateModalOpen(false);
    setInserting(false);

    // Reset Insert modal data
    setValues(null);
    setProfileList([]);
    setStudentList([]);
    setHelperText(false);
    setStudentHelperText(false);
    setPendingSubmit(false);
    setNewFiles([]);

    // Add current user to the duplicate item's profile list if not already present
    const existingProfiles = duplicateItem.scientificResearch?.scientificResearchProfile || [];
    const currentUserExists = existingProfiles.some((p) => p.profileId === props.profile?.id);

    if (!currentUserExists) {
      const updatedItem = {
        ...duplicateItem.scientificResearch,
        scientificResearchProfile: [
          ...existingProfiles,
          {
            profileId: props.profile?.id,
            roleInPaper: "member",
            isInternal: true,
            externalName: "",
          },
        ],
        journal: duplicateItem.journal,
        journalDomestic: duplicateItem.journalDomestic,
        conference: duplicateItem.conference,
        _fromDuplicate: true, // Flag to indicate this came from duplicate selection
      };
      // Trigger update modal with the modified item
      if (props.onEditDuplicate) {
        props.onEditDuplicate(updatedItem);
      }
    } else {
      // Just open for editing
      if (props.onEditDuplicate) {
        props.onEditDuplicate({
          ...duplicateItem.scientificResearch,
          journal: duplicateItem.journal,
          journalDomestic: duplicateItem.journalDomestic,
          conference: duplicateItem.conference,
          _fromDuplicate: true, // Flag to indicate this came from duplicate selection
        });
      }
    }
  };

  const getTypeAsTitle = (type) => {
    switch (type) {
      case "journalInternational":
        return "trên tạp chí quốc tế";
      case "journalDomestic":
        return "trên tạp chí trong nước";
      case "conference":
        return "trên hội thảo quốc tế";
      case "conferenceDomestic":
        return "trên hội thảo trong nước";
      case "chapter":
        return "là chương sách";
      case "workingPaper":
        return "đang thực hiện";
      case "other":
        return "trên tạp chí khác";
      default:
        return "";
    }
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === 0)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type === "scientificResearch"
  // );

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === 0)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type === "scientificResearch-" + props.filter);
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear, props.filter]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const propsValues = {
    values: values,
    profileList: profileList,
    setValues: setValues,
    handleInsert: handleInsert,
    handleRemove: handleRemove,
    handleChangeForm: handleChangeForm,
    handleChangeProfileList: handleChangeProfileList,
  };

  return (
    <Dialog
      fullWidth
      maxWidth={values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "xl" : "lg"}
      open={inserting}
      onClose={() => setInserting(false)}
      disableBackdropClick
    >
      <DialogTitle>{`Thêm bài báo ${getTypeAsTitle(props.filter)}`}</DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div
          style={{
            display: "flex",
            flex: "1 1 60%",
            minWidth: 0,
          }}
        >
          <Grid container justifyContent="center" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                getOptionLabel={(option) => option.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id || null)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            {props.filter === "journalInternational" && <JournalInternational {...propsValues} />}
            {props.filter === "journalDomestic" && <JournalDomestic {...propsValues} />}
            {props.filter === "conference" && <Conference {...propsValues} />}
            {props.filter === "conferenceDomestic" && <ConferenceDomestic {...propsValues} />}
            {props.filter === "chapter" && <Chapter {...propsValues} />}
            {props.filter === "workingPaper" && <WorkingPaper {...propsValues} />}
            {props.filter === "other" && <Other {...propsValues} />}

            {props.filter === "journalInternational" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Loại tạp chí quốc tế"
                  variant="outlined"
                  value={values?.internationalJournalType || ""}
                  onChange={(event) => handleChangeForm("internationalJournalType", event.target.value)}
                >
                  <MenuItem value="01">Thuộc danh mục Web of science</MenuItem>
                  <MenuItem value="02">Scopus</MenuItem>
                  <MenuItem value="03">ACI</MenuItem>
                  <MenuItem value="04">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "journalDomestic" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Loại tạp chí trong nước"
                  variant="outlined"
                  value={values?.domesticJournalType || ""}
                  onChange={(event) => handleChangeForm("domesticJournalType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được HĐGSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc Web of science</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">ACI</MenuItem>
                  <MenuItem value="6">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "conference" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Loại hội thảo quốc tế"
                  variant="outlined"
                  value={values?.internationalConferenceType || ""}
                  onChange={(event) => handleChangeForm("internationalConferenceType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc danh mục WoS</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">Khác</MenuItem>
                </TextField>
              </Grid>
            )}
            {props.filter === "conferenceDomestic" && (
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Loại hội thảo trong nước"
                  variant="outlined"
                  value={values?.domesticConferenceType || ""}
                  onChange={(event) => handleChangeForm("domesticConferenceType", event.target.value)}
                >
                  <MenuItem value="1">Được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="2">Không được Hội đồng GSNN tính điểm</MenuItem>
                  <MenuItem value="3">Thuộc danh mục WoS</MenuItem>
                  <MenuItem value="4">Scopus</MenuItem>
                  <MenuItem value="5">Khác</MenuItem>
                </TextField>
              </Grid>
            )}

            {props.filter !== "workingPaper" && values?.purposeId === 5 && (
              <>
                {/* <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    error={!values?.timeResearchDetailCode}
                  >
                    {timeResearchDetailList?.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description}`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null} disabled>
                        Chưa có dữ liệu
                      </MenuItem>
                    )}
                  </TextField>
                  {!values?.timeResearchDetailCode && <FormHelperText error>Phải chọn một nhiệm vụ!</FormHelperText>}
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values?.isOvertimeCountable || false}
                    onChange={(event) => handleChangeForm("isOvertimeCountable", event.target.checked)}
                    color="primary"
                  />
                }
                label="Tính giờ quy đổi riêng"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Số giờ quy đổi riêng"
                variant="outlined"
                value={values?.overtimeHours ?? ""}
                disabled={!values?.isOvertimeCountable}
                onChange={(event) => handleChangeForm("overtimeHours", parseFloat(event.target.value) || 0)}
                inputProps={{
                  min: 0,
                  step: 0.1,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" style={{ color: "rgba(0, 0, 0, 0.54)", fontStyle: "italic" }}>
                Công thức quy đổi: 0,01 điểm công trình khoa học theo danh mục cho điểm của Hội đồng được tính bằng 02
                giờ.
              </Typography>
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid
                      item
                      xs={
                        props.filter === "workingPaper" || (values?.purposeId !== 1 && values?.purposeId !== 99999999)
                          ? 5
                          : 3
                      }
                    >
                      <Autocomplete
                        disableClearable
                        options={profileListFromProps}
                        getOptionLabel={(option) => option.name}
                        value={profileListFromProps?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                          if (parseInt(profile?.id) >= 0) setHelperText(false);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={helperText && e.profileId === null}
                            size="small"
                            label="Thành viên"
                            variant="outlined"
                          />
                        )}
                      />
                      {helperText && e.profileId === null && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 3}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={
                      props.filter === "workingPaper" || (values?.purposeId !== 1 && values?.purposeId !== 99999999)
                        ? 5
                        : 3
                    }
                  >
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInPaper-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInPaper-label"
                        value={e?.roleInPaper || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInPaper", event.target.value)}
                      >
                        <option value="main">Tác giả chính</option>
                        <option value="member">Đồng tác giả</option>
                        {/* <option value="mainOther">Tác giả chính tính hộ</option>
                        <option value="memberOther">Đồng tác giả tính hộ</option> */}
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid
                      item
                      xs={3}
                      style={{
                        display: props.filter === "workingPaper" ? "none" : "flex",
                      }}
                    >
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid
                      item
                      xs={3}
                      style={{
                        display: props.filter === "workingPaper" ? "none" : "flex",
                      }}
                    >
                      <FormControl fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      // className="error-button"
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xóa
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {studentList.map((e, index) => (
                <Grid key={`student-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                  <Grid item xs={5}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Tên sinh viên"
                      value={e?.studentName || ""}
                      error={studentHelperText && e.studentName === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                    />
                    {studentHelperText && e.studentName === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Mã sinh viên"
                      value={e?.studentCode || ""}
                      error={studentHelperText && e.studentCode === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                    />
                    {studentHelperText && e.studentCode === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={studentHelperText && !e?.roleInPaper}
                    >
                      <InputLabel
                        id={`student-roleInPaper-label-${index}`}
                        style={{ padding: "0 8px", backgroundColor: "white" }}
                      >
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId={`student-roleInPaper-label-${index}`}
                        value={e?.roleInPaper || "member"}
                        onChange={(event) => handleChangeStudentList(index, "roleInPaper", event.target.value)}
                      >
                        <option value="main">Tác giả chính</option>
                        <option value="member">Đồng tác giả</option>
                      </Select>
                    </FormControl>
                    {studentHelperText && !e?.roleInPaper && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemoveStudent(index)}
                    >
                      Xóa
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Lớp"
                      value={e?.class || ""}
                      onChange={(event) => handleChangeStudentList(index, "class", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Ngành học"
                      value={e?.major || ""}
                      onChange={(event) => handleChangeStudentList(index, "major", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Khóa"
                      value={e?.cohort || ""}
                      onChange={(event) => handleChangeStudentList(index, "cohort", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Số CMND/CCCD"
                      value={e?.identity || ""}
                      onChange={(event) => handleChangeStudentList(index, "identity", event.target.value)}
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsertStudent}>
                Thêm sinh viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flex: "0 0 380px",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Typography
            variant="subtitle2"
            style={{
              marginBottom: 4,
              color:
                props.filter !== "workingPaper" && !values?.doi && newFiles.length === 0
                  ? "#f44336"
                  : "rgba(0,0,0,0.54)",
            }}
          >
            File minh chứng
            {props.filter !== "workingPaper" && !values?.doi && (
              <span style={{ color: "#f44336", marginLeft: 2 }}>*</span>
            )}
          </Typography>
          {props.filter !== "workingPaper" && !values?.doi && newFiles.length === 0 && (
            <Typography variant="caption" style={{ color: "#f44336", display: "block", marginBottom: 6 }}>
              Bắt buộc khi không có DOI
            </Typography>
          )}
          <MultiFileManager fileUrls={[]} setFileUrls={() => {}} newFiles={newFiles} setNewFiles={setNewFiles} />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div style={{ float: "right" }}>
            <Button
              variant="outlined"
              // color="secondary"
              onClick={() => handleClose()}
              style={{ marginRight: 4 }}
            >
              Huỷ
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={
                props.filter !== "workingPaper" &&
                (!(values?.numberMainAuthor > 0) ||
                  !(values?.numOfMember > 0) ||
                  (!!["journalInternational", "journalDomestic", "conference", "conferenceDomestic"].find(
                    (e) => props.filter === e,
                  ) &&
                    false) ||
                  // (!(values?.submissionMonth > 0) || !(values?.acceptedMonth > 0))
                  (values?.purposeId === 5 && !values?.timeResearchDetailCode) ||
                  (!values?.doi && newFiles.length === 0))
                // (props.filter !== "workingPaper" && (!(values?.numberMainAuthor > 0) ||
                //   ((
                //     !!["journalInternational", "journalDomestic", "conference", "conferenceDomestic"].find((e) => props.filter === e)
                //   ) && (
                //     !(values?.submissionMonth > 0) ||
                //     !(values?.acceptedMonth > 0)
                //   )) ||
                //   !(values?.numOfMember > 0))) ||
                // (values?.purposeId === 5 && !values?.timeResearchDetailCode) ||
                // (!values?.doi && files.length === 0)
              }
              onClick={() => handleSubmit()}
            >
              Xác nhận
            </Button>
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        duplicates={duplicateList}
        onClose={() => {
          setDuplicateModalOpen(false);
          setPendingSubmit(false);
          // Reset Insert modal data
          setValues(null);
          setProfileList([]);
          setStudentList([]);
          setHelperText(false);
          setStudentHelperText(false);
          setInserting(false);
          setNewFiles([]);
        }}
        onSelectDuplicate={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  pushNoti: (payload) => dispatch(notification(payload)),
  resetDetail: () => dispatch(resetDetail()),
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertScientificResearch: (payload) => dispatch(insertScientificResearch(payload)),
  insertScientificResearchOther: (payload) => dispatch(insertScientificResearchOther(payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  updateScientificResearch: (id, payload) => dispatch(updateScientificResearch(id, payload)),
  getTimeResearchInformation: (profileId, year) => dispatch(getTimeResearchInformation(profileId, year)),
  checkDuplicatePublication: (payload) => dispatch(checkDuplicatePublication(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(SolutionInsertModal));

